/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_Windows_Step1Inputs */

const en_gc_resources_download_windows_step1 = /** @type {(inputs: Gc_Resources_Download_Windows_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download the .msi installer.`)
};

const zh_gc_resources_download_windows_step1 = /** @type {(inputs: Gc_Resources_Download_Windows_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载 .msi 安装程序。`)
};

/**
* | output |
* | --- |
* | "Download the .msi installer." |
*
* @param {Gc_Resources_Download_Windows_Step1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_windows_step1 = /** @type {((inputs?: Gc_Resources_Download_Windows_Step1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_Windows_Step1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_windows_step1(inputs)
	return zh_gc_resources_download_windows_step1(inputs)
});
export { gc_resources_download_windows_step1 as "gc.resources.download.windows.step1" }